module.exports = __webpack_public_path__ + "dash_20_app_assets/img/infinitywall.a65f94ed.png";